import { Button, Modal } from 'antd'

import { getStatusLabel } from '../constants'
import { useSaleOrders } from '../hooks/useSaleOrders'
import SaleOrdersTable from './SaleOrdersTable'

interface Props {
  open: boolean
  status?: string
  startDate?: string
  endDate?: string
  shopId?: string
  by?: 'order' | 'settlement'
  paymentType?: 'cod' | 'transfer'
  title?: string // override หัว modal (เช่น รายวัน ใช้วันที่แทนสถานะ)
  onClose: () => void
}

const OrdersModal = ({
  open,
  status,
  startDate,
  endDate,
  shopId,
  by,
  paymentType,
  title,
  onClose,
}: Props) => {
  const {
    items,
    isLoading,
    error,
    startIndex,
    hasNext,
    hasPrev,
    goNext,
    goPrev,
  } = useSaleOrders({
    enabled: open,
    status,
    startDate,
    endDate,
    shopId,
    by,
    paymentType,
  })

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={title ?? `คำสั่งซื้อ — ${getStatusLabel(status)}`}
      width={1080}
      footer={<Button onClick={onClose}>ปิด</Button>}
    >
      <SaleOrdersTable
        items={items}
        isLoading={isLoading}
        error={error}
        startIndex={startIndex}
        hasNext={hasNext}
        hasPrev={hasPrev}
        goNext={goNext}
        goPrev={goPrev}
      />
    </Modal>
  )
}

export default OrdersModal
